import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from 'components/Loader';

import './style.scss';

const InfoCardIcon = ({ title, children, showCard, showContent, pending, icon }) => {
  if (!showCard && !showContent && !pending) {
    return <></>;
  }

  let render;
  if (pending) {
    render = <Loader type="small" color="#000" />;
  } else if (!showContent) {
    render = <></>;
  } else {
    if (typeof children === 'string' && children.length > 100) {
      render = children.slice(0, 100) + '...';
    } else {
      render = children;
    }
  }

  return (
    <div className="infocard">
      <div className="title">{title} {icon}</div>
      <div className="infocard-block" title={typeof children === 'string' ? children : ''}>
        {render}
      </div>
    </div>
  );
};

InfoCardIcon.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  pending: PropTypes.bool,
  showCard: PropTypes.bool,
  showContent: PropTypes.bool,
  icon: PropTypes.node
};

InfoCardIcon.defaultProps = {
  pending: false,
  showCard: true,
  showContent: true,
  icon: ''
};

export { InfoCardIcon };
